import { connect } from 'react-redux';
import DashboardOpportunityCard from './DashboardOpportunityCard';
const mapStateToProps = (state) => ({
    email: state.roles.email,
});
export default connect(mapStateToProps)(DashboardOpportunityCard);
